import React from 'react'
import "./onlineAssistance.scss"

//Imagens:
import ImgWhereYouNeed from "../../../../assets/tickets/Ativo_3-8.png"
import { useTranslation } from 'react-i18next'

function OnlineAssistance() {
  const {t} =  useTranslation()

  return (
    <div className='container-b2c-profits'>
        <div className="img-b3c-profits">
            <img src={ImgWhereYouNeed} alt="" />
        </div>
        <div className='texts-b2c-profits'>
            <h1>{t("tickets.title")}</h1>
            <p>{t("tickets.section_text")}</p>
            <a href="/form">
              <button id='btn-b3c-profits'>{t("buttons.demo_btn_alternative_text_1")}</button>
            </a>
        </div>
    </div>
  )
}

export default OnlineAssistance